<!-- 柱状图 -->
<template>
    <div class="wh100" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    name: "EchartBar",
    data() {
        return {};
    },
    props: {
        id: {
            type: String,
            default: "bar",
        },
        seriesData: {
            type: Array,
            default: function () {
                return [0, 0, 0, 0, 0];
            },
        },
        xAxisData: {
            type: Array,
            default: function () {
                return ["1"];
            },
        },
    },
    mounted() {
        this.show();
    },
    methods: {
        show() {
            var chartDom = document.getElementById(this.id);
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                color: ["#7C70FF"],
                yAxis: {
                    type: "value",
                },
                xAxis: {
                    type: "category",
                    data: this.xAxisData,
                },
                series: [
                    {
                        barWidth: 12,
                        type: "bar",
                        data: this.seriesData,
                    },
                ],
            };
            option && myChart.setOption(option);
        },
    },
};
</script>
    
<style scoped>
.wh100 {
    width: 100%;
    height: 100%;
}
</style>